export var accountHelper = function accountHelper(token) {
  var _token$account;

  if (!token) {
    return {};
  }

  return (_token$account = token.account) === null || _token$account === void 0 ? void 0 : _token$account.idToken;
};